import React from "react";
import { motion } from "framer-motion";
import "./Process.css";

const steps = [
  { title: "Discuss", text: "Tell us about your business and what you need. A free call, no obligation." },
  { title: "Quote", text: "You get a clear scope, timeline and fixed price before any work begins." },
  { title: "Build", text: "We design and develop in short cycles, with a demo every week." },
  { title: "Launch and support", text: "We go live together, train your team and stay on for updates and fixes." },
];

const Process = () => (
  <section id="process" className="lk-section">
    <div className="lk-container">
      <motion.div
        className="lk-section-head"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <div>
          <div className="lk-eyebrow">How we work</div>
          <h2 className="lk-h2">From first call to launch in four steps.</h2>
        </div>
        <p className="lk-lead">A simple process, so you always know what happens next.</p>
      </motion.div>

      <ol className="lk-steps">
        {steps.map((s, i) => (
          <motion.li
            key={s.title}
            className="lk-card lk-step"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
          >
            <span className="lk-step-num">{String(i + 1).padStart(2, "0")}</span>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);

export default Process;
